export default __webpack_public_path__ + "static/media/walkthrough-3.b2e9016d.png";